import React, { useMemo } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const ProtectedRoute = ({ children, tokenKey, redirectPath }) => {
  const location = useLocation();

  // 1. Check for SSO token passed via URL parameter (e.g. from Mobile App In-App WebView)
  const token = useMemo(() => {
    const searchParams = new URLSearchParams(location.search);
    const ssoToken = searchParams.get('token') || searchParams.get('auth_token') || searchParams.get('sso_token');
    
    if (ssoToken && ssoToken.trim() !== '') {
      const cleanToken = ssoToken.trim();
      // Store under the required token key (bdToken, managerToken, sellerToken, agencyToken, adminToken)
      sessionStorage.setItem(tokenKey, cleanToken);
      sessionStorage.setItem('token', cleanToken);
      sessionStorage.setItem('authToken', cleanToken);
      
      // Clean query parameter from URL without triggering a page reload
      searchParams.delete('token');
      searchParams.delete('auth_token');
      searchParams.delete('sso_token');
      const cleanSearch = searchParams.toString();
      const cleanUrl = window.location.pathname + (cleanSearch ? `?${cleanSearch}` : '') + window.location.hash;
      window.history.replaceState({}, document.title, cleanUrl);

      return cleanToken;
    }

    return sessionStorage.getItem(tokenKey);
  }, [location.search, tokenKey]);

  if (!token) {
    return <Navigate to={redirectPath} replace />;
  }

  return children;
};

export default ProtectedRoute;

